/**
 * eBoutique API
 * eBoutique API
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { SubmissionEntityValue } from './submissionEntityValue';

export class SubmissionWrapper {
  submissionType?: string;
  dirName?: string;
  fileName?: string;
  server?: string;
  userid?: string;
  password?: string;
  userId?: string;
  fileStream?: string;
  sellerNo?: number;
  searchDate?: {date: string};
  currentMenuOption?: string;
  servicerList5Digit?: string;
  status?: string;
  trackingId?: number;
  submissionEntityValuevo?: SubmissionEntityValue;
  submsnID?: number;
  queryMap?: any;
  severity?: string;
  keys?: any;
  file?: string;
  fileUploadId: string;
  listSubmissionEntityValue?: Array<SubmissionEntityValue>;
}
